"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateHolidaySchema = exports.createHolidaySchema = exports.holidayShape = exports.holidayTypeEnum = void 0;
const zod_1 = require("zod");
exports.holidayTypeEnum = zod_1.z.enum(['NATIONAL', 'REGIONAL', 'HOSPITAL']);
exports.holidayShape = {
    date: zod_1.z.coerce.date(),
    name: zod_1.z.string().min(1).max(255),
    type: exports.holidayTypeEnum,
    branchId: zod_1.z.string().uuid().optional(),
};
exports.createHolidaySchema = zod_1.z.object(exports.holidayShape);
exports.updateHolidaySchema = exports.createHolidaySchema.partial();
//# sourceMappingURL=holiday.schema.js.map